<template>
  <span :class="'num-' + id">
    {{ num.toFixed(0) }}
  </span>
</template>

<script>
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default {
  name: "GsapCount",
  props: {
    value: {
      type: Number,
      default: 0
    },
    duration: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      num: 0, // 初始值
      id: Math.random().toString(16).slice(2) // 随机生成 id
    };
  },
  methods: {
    AnimateToValue() {
      gsap.to(this.$data, {
        scrollTrigger: ".num-" + this.id,
        duration: this.duration,
        num: this.value
      });
    }
  },
  watch: {
    value() {
      this.AnimateToValue();
    }
  },
  mounted() {
    gsap.registerPlugin(ScrollTrigger);
    this.AnimateToValue();
  }
};
</script>

<style scoped></style>
